import { render, staticRenderFns } from "./assetsTypeForm.vue?vue&type=template&id=62516562&"
import script from "./assetsTypeForm.vue?vue&type=script&lang=js&"
export * from "./assetsTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./assetsTypeForm.vue?vue&type=style&index=0&id=62516562&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports